@if ({state: layout$ | async, context: context$ | async, crumbs: crumbs$ | async, available: available$ | async, influencer: isInfluencer(), dark: isDarkTheme$ | async}; as vm) {
  @if (vm.state?.visible) {
    <!-- The top menu: the navbar as it always looked, its items now from the server. -->
    @if (vm.state.topLayout) {
    <nav class="app-navbar new-styles navbar navbar-expand-md navbar-light bg-light sn-header"
         aria-label="Main">
      <div class="navbar-top-row">
        <a class="navbar-brand" routerLink="/projects" aria-label="Snöball home">
          <div class="logo-container" [class.logo-container--mark]="vm.context.inProjectContext">
            @if (vm.context.inProjectContext) {
            <img class="logo-mark" alt="Snöball" src="../assets/images/logo_mark_navbar.png">
            }
            @if (!vm.context.inProjectContext) {
              @if (!vm.dark) {
              <img alt="Snöball" src="../assets/images/logo_with_background_and_slogan_new.png">
              }
              @if (vm.dark) {
              <img alt="Snöball" src="../assets/images/logo_with_background_and_slogan_new-transparent.png">
              }
            }
          </div>
        </a>
      </div>
      <div class="navbar-collapse navbar-mobile-panel sn-header__panel">
        @if (vm.available) {
        <app-nav-top-menu>
          @if (vm.context.inProjectContext) {
          <li app-nav-project-switcher variant="navbar"
              class="nav-item dropdown projects-dropdown projects-links"></li>
          }
        </app-nav-top-menu>
        } @else {
      <p class="sn-header__unavailable" role="status">
        Menu unavailable. <a href="" (click)="$event.preventDefault(); reload()">Reload</a>
      </p>
        }
        <app-nav-toolbar [showSearch]="true" [showTasks]="!vm.influencer"></app-nav-toolbar>
        <div app-nav-user-menu variant="top" class="login-part dropdown"></div>
      </div>
    </nav>
    } @else {
      <header class="app-navbar sn-header sn-header--bar">
        @if (vm.state.presentation === 'drawer') {
        <a class="sn-header__mark" routerLink="/projects" aria-label="Snöball home">
          <img alt="" src="../assets/images/logo_mark_white.png" width="88" height="106">
        </a>
        }
        @if (vm.state.presentation === 'drawer') {
        <button type="button" class="sn-icon-button sn-header__hamburger"
                data-sn-hamburger aria-controls="sn-sidebar" [attr.aria-expanded]="vm.state.drawerOpen"
                aria-label="Open menu" (click)="openDrawer()">
          <i class="fa-solid fa-bars" aria-hidden="true"></i>
        </button>
        }
        @if (vm.available) {
        <app-nav-breadcrumb [crumbs]="vm.crumbs"></app-nav-breadcrumb>
        } @else {
      <p class="sn-header__unavailable" role="status">
        Menu unavailable. <a href="" (click)="$event.preventDefault(); reload()">Reload</a>
      </p>
        }
        <app-nav-toolbar [showSearch]="true" [showTasks]="!vm.influencer"></app-nav-toolbar>
        <div app-nav-user-menu variant="bar" class="sn-header__user dropdown"></div>
      </header>
    }

    <!-- Beside the side menu, and on a phone: the breadcrumb in the menu's place. -->

  }

}
